module.exports = __webpack_public_path__ + "static/media/coming.dd9551e4.gif";